import { Outlet } from 'react-router-dom';
import {
  LayoutDashboard, PackageOpen, RefreshCw, AlertTriangle,
  ListTodo, ShieldCheck, Mail, FileText, BookOpen,
  Building2, Coins, CalendarCheck
} from 'lucide-react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { useShop } from '../../hooks/useShop';
import { useDashboard } from '../../hooks/useDashboard';
import { useAuth } from '../../contexts/AuthContext';

export default function AuditorShell() {
  const { user } = useAuth();
  const { shops, currentShopId, switchShop } = useShop();
  const { data: dashboard, loading, refresh } = useDashboard(currentShopId);

  // Derive badge counts from dashboard data
  const partsToReturnCount = dashboard?.ordered_never_received?.count || 0;
  const creditsCount = dashboard?.credits?.count || 0;
  const costIssuesCount = (dashboard?.cost_discrepancies?.count || 0)
    + (dashboard?.missing_invoices?.count || 0);

  const sections = [
    {
      label: 'Daily Work',
      items: [
        { to: '/auditor', end: true, label: 'Daily Queue', icon: <LayoutDashboard /> },
        { to: '/auditor/daily-audit', label: 'Daily Audit', icon: <CalendarCheck /> },
        { to: '/auditor/parts-to-return', label: 'Parts to Return', icon: <PackageOpen />, badge: partsToReturnCount },
        { to: '/auditor/core-charges', label: 'Core Charges', icon: <Coins /> },
        { to: '/auditor/credits', label: 'Credits & Refunds', icon: <RefreshCw />, badge: creditsCount },
        { to: '/auditor/cost-issues', label: 'Cost Issues', icon: <AlertTriangle />, badge: costIssuesCount },
      ],
    },
    {
      label: 'Workflow',
      items: [
        { to: '/auditor/tasks', label: 'Tasks', icon: <ListTodo /> },
        { to: '/auditor/audit-email', label: 'Daily Audit Email', icon: <Mail /> },
      ],
    },
    {
      label: 'Setup',
      items: [
        { to: '/auditor/vendors', label: 'Vendor Profiles', icon: <Building2 /> },
        { to: '/auditor/vendors-needed', label: 'Vendors Needed', icon: <ListTodo /> },
        { to: '/auditor/exceptions', label: 'Exception Rules', icon: <ShieldCheck /> },
      ],
    },
    {
      label: 'References',
      items: [
        { to: '/auditor/statements', label: 'Statements', icon: <FileText /> },
        { to: '/auditor/audit-trail', label: 'Audit Trail', icon: <BookOpen /> },
      ],
    },
  ];

  return (
    <div className="min-h-screen flex bg-[var(--color-cream-100)] font-sans">
      <Sidebar
        brand={{ initials: 'R', name: 'Reconciliation Hub', tagline: 'Auditor workspace' }}
        sections={sections}
      />

      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar
          user={user || {}}
          currentShop={currentShopId}
          shops={shops}
          onShopChange={switchShop}
          notifications={0}
          onRefresh={refresh}
        />

        <main className="flex-1 overflow-y-auto">
          <div className="max-w-[1400px] mx-auto px-6 py-8">
            <Outlet context={{ dashboard, loading, refresh }} />
          </div>
        </main>
      </div>
    </div>
  );
}
